import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import urlShortIcon from "../assets/images/icons/floating-icon-white.svg";
import SingleUrlOffCanvas from './SingleUrlOffCanvas';
import BulkUrlOffCanvas from './BulkUrlOffCanvas';

const FloatingActionButton = () => {
  const [show, setShow] = useState(false);
  const [activeOffCanvas, setActiveOffCanvas] = useState(null);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const token = localStorage.getItem('token');
        if (token) {
          const decodedToken = jwtDecode(token);
          setIsSuperAdmin(decodedToken.roles?.includes('SUPERADMIN') || false);
        }
      } catch (err) {
        console.error('Error decoding token:', err);
        setIsSuperAdmin(false);
      }
    };

    checkUserRole();
  }, []);

  const handleSingleUrlClick = () => {
    setShow(false);
    setActiveOffCanvas('single');
  };

  const handleBulkUrlClick = () => {
    setShow(false);
    setActiveOffCanvas('bulk');
  };

  const handleCloseOffCanvas = () => {
    setActiveOffCanvas(null);
  };

  if (isSuperAdmin || location.pathname === '/urlShorten') {
    return null;
  }

  return (
    <>
      <div className="floating-button-container">
        <Button
          variant="success"
          className="floating-button p-0"
          onClick={() => setShow(!show)}
        >
          <img src={urlShortIcon} alt="URL Shortener" width="20" height="20" />
        </Button>

        {show && (

 <div className="floating-menu">
          <div className="floating-menu-box">

            <button
              className="menu-item fs-12 border-0"
              onClick={handleSingleUrlClick}
            >
              Single URL
            </button>
            <button
              className="menu-item fs-12 border-0"
              onClick={handleBulkUrlClick}
            >
              Bulk URL
            </button>
          </div>
</div>
        )}
      </div>

      {show && (
        <div className="overlay" onClick={() => setShow(false)} />
      )}

      <SingleUrlOffCanvas 
        show={activeOffCanvas === 'single'} 
        onHide={handleCloseOffCanvas} 
      />
      <BulkUrlOffCanvas 
        show={activeOffCanvas === 'bulk'} 
        onHide={handleCloseOffCanvas} 
      />
    </>
  );
};

export default FloatingActionButton;
